import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuscadorPA } from '../models/buscadorPA';
import { PedidoAbastecimientoCabecera } from '../models/pedidoAbastecimientoCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PAService {

  private paServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.paServerUri = this.apiUrl + '/' + this.configService.PAURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  aprobarPedidoAbastecimiento(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'AprobarPedidoAbastecimiento', pac, { headers: this.getHeaders() });
  }
  aprobarPendConformarPedidoAbastecimiento(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'AprobarPendConformarPedidoAbastecimiento', pac, { headers: this.getHeaders() });
  }
  rechazarPedidoAbastecimiento(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'RechazarPedidoAbastecimiento', pac, { headers: this.getHeaders() });
  }
  cPedidosAbastecimiento(buscador: BuscadorPA) {
    return this.httpCliente.post(this.paServerUri + 'CPedidosAbastecimiento', buscador, { headers: this.getHeaders() });
  }
  cPedidoAbastecimiento(idPais: string, idCompania: string, idSalesOrg: string, idTipoOrden: string, codigo: number) {
    return this.httpCliente.get(this.paServerUri + 'CPedidoAbastecimiento?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoOrden=" + idTipoOrden + "&codigo=" + codigo, { headers: this.getHeaders() });
  }
  amPedidoAbastecimiento(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'AMPedidoAbastecimiento', pac, { headers: this.getHeaders() });
  }
  aPedidoAbastecimientoItem(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'APedidoAbastecimientoItem', pac, { headers: this.getHeaders() });
  }
  mPedidoAbastecimientoItem(pac: PedidoAbastecimientoCabecera) {
    return this.httpCliente.post(this.paServerUri + 'MPedidoAbastecimientoItem', pac, { headers: this.getHeaders() });
  }
  bPedidoAbastecimientoItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.paServerUri + 'BPedidoAbastecimientoItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }
  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCLiente: string, idFormaPago: string, idGrupoCliente: string, idTipoOrden: string, search: string) {
    return this.httpCliente.get(this.paServerUri + 'CListasPreciosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCLiente=" + nroCLiente + "&idFormaPago=" + idFormaPago + "&idGrupoCliente=" + idGrupoCliente + "&idTipoOrden=" + idTipoOrden + "&search=" + search, { headers: this.getHeaders() });
  }
  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, idPlanta: string, idUbicacionAlmacenamiento: string, search: string) {
    idMoneda = typeof idMoneda == 'undefined' || idMoneda == null ? "" : idMoneda
    idTerminoPago = typeof idTerminoPago == 'undefined' || idTerminoPago == null ? "" : idTerminoPago
    idTipoListaPrecios = typeof idTipoListaPrecios == 'undefined' || idTipoListaPrecios == null ? "" : idTipoListaPrecios
    return this.httpCliente.get(this.paServerUri + 'CListaPrecioItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios + "&idTerminoPago=" + idTerminoPago + "&idMoneda=" + idMoneda + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&search=" + search, { headers: this.getHeaders() });

  }
  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.paServerUri + 'CTerminosPagoTipoListaPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios, { headers: this.getHeaders() });
  }
  cStoragesLocationsPlanta(idPais: string, idCompania: string, idSalesOrg: string, idPlanta) {
    return this.httpCliente.get(this.paServerUri + 'CStoragesLocationsPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta, { headers: this.getHeaders() });
  }
  cDireccionesDistribuidorCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, nroClienteDistribuidor: string) {
    return this.httpCliente.get(this.paServerUri + 'CDireccionesDistribuidorCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&nroClienteDistribuidor=" + nroClienteDistribuidor, { headers: this.getHeaders() });
  }
  cListaPreciosDivisionCabecera(idPais: string, idCompania: string, idSalesOrg: string, idComprobante: string, idDivision: string) {
    return this.httpCliente.get(this.paServerUri + 'CListaPreciosDivisionCabecera?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idComprobante=" + idComprobante + "&idDivision=" + idDivision, { headers: this.getHeaders() })
  }
  cPedidoAbastecimientoItem(codigoItem: number) {
    return this.httpCliente.get(this.paServerUri + 'CPedidoAbastecimientoItem?codigoItem=' + codigoItem, { headers: this.getHeaders() });
  }
}
